import Main from '@/views/main/main'
import onlyRouterView from '@/views/common-router-view/router-view'

export const mainRouter = [
    {
        path: '/tags-cate',
        name: 'tags-cate',
        meta: {
            title: '标签分类管理',
            icon: 'ios-pricetag'
        },
        component: Main,
        children: [
            {
                path: 'product-cate',
                name: 'product-cate',
                meta: {
                    title: '保险分类',
                    access_name: 'product_category_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'product-cate',
                        meta: {
                            title: '保险分类',
                            alias: 'product',
                            access_name: 'product_category_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/product-category'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'poster-cate',
                name: 'poster-cate',
                meta: {
                    title: '海报分类',
                    access_name: 'poster_category_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'poster-cate',
                        meta: {
                            title: '海报分类',
                            alias: 'poster',
                            access_name: 'poster_category_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-list.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'poster-cate',
                        meta: {
                            title: '新增海报分类',
                            type: 'category-add',
                            alias: 'poster',
                            access_name: 'poster_category_create'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'poster-cate',
                        meta: {
                            title: '编辑海报分类',
                            type: 'category-edit',
                            alias: 'poster',
                            access_name: 'poster_category_edit'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'article-cate',
                name: 'article-cate',
                meta: {
                    title: '文章分类',
                    access_name: 'article_category_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'article-cate',
                        meta: {
                            title: '文章分类',
                            alias: 'article',
                            access_name: 'article_category_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-list.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'article-cate',
                        meta: {
                            title: '新增文章分类',
                            type: 'category-add',
                            alias: 'article',
                            access_name: 'article_category_create'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'article-cate',
                        meta: {
                            title: '编辑文章分类',
                            type: 'category-edit',
                            alias: 'article',
                            access_name: 'article_category_edit'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'video-cate',
                name: 'video-cate',
                meta: {
                    title: '视频分类',
                    access_name: 'video_category_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'video-cate',
                        meta: {
                            title: '视频分类',
                            alias: 'video',
                            access_name: 'video_category_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-list.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'video-cate',
                        meta: {
                            title: '新增视频分类',
                            type: 'category-add',
                            alias: 'video',
                            access_name: 'video_category_create'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'video-cate',
                        meta: {
                            title: '编辑视频分类',
                            type: 'category-edit',
                            alias: 'video',
                            access_name: 'video_category_edit'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/category-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'article-tags',
                name: 'article-tags',
                meta: {
                    title: '文章标签',
                    access_name: 'article_tag_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'article-tags',
                        meta: {
                            title: '文章标签',
                            access_name: 'article_tag_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/tags-list.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'question-tags',
                name: 'question-tags',
                meta: {
                    title: '问答标签',
                    access_name: 'question_tag_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'question-tags',
                        meta: {
                            title: '问答标签',
                            access_name: 'question_tag_list'
                        },
                        component: resolve => {
                            require(['@/views/tags-category-manage/questionTags'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/policy-rutler',
        name: 'policy-rutler',
        meta: {
            title: '保单管家',
            icon: 'ios-body'
        },
        component: Main,
        children: [
            {
                path: 'list',
                name: 'policy-rutler-list',
                meta: {
                    title: '保单列表',
                    access_name: 'get_policy_page_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'policy-rutler-list',
                        meta: {
                            title: '保单列表',
                            access_name: 'get_policy_page_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-butler/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'policy-rutler-list',
                        meta: {
                            title: '保单详情',
                            type: 'add',
                            access_name: 'get_policy_page_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-butler/detail.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'policy-examine-list',
                name: 'policy-examine-list',
                meta: {
                    title: '人核订单列表',
                    access_name: 'get_manpower_page_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'policy-examine-list',
                        meta: {
                            title: '保单列表',
                            access_name: 'get_manpower_page_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-examine/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'policy-examine-list',
                        meta: {
                            title: '保单详情',
                            type: 'add',
                            access_name: 'get_manpower_page_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-examine/detail.vue'], resolve)
                        }
                    },
                    {
                        path: 'examine-detail/:id',
                        name: 'policy-examine-list',
                        meta: {
                            title: '人核订单详情',
                            type: 'add',
                            access_name: 'get_manpower_page_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-examine/examine-detail.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'unmatched-product',
                name: 'unmatched-product',
                meta: {
                    title: '未匹配产品'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'unmatched-product',
                        meta: {
                            title: '保单列表',
                            access_name: 'not_match_policy_list'
                        },
                        component: resolve => {
                            require(['@/views/policy-manage/unmatched-product'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'pre-underwriting',
                name: 'pre-underwriting',
                meta: {
                    title: '预核保进度'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'pre-underwriting',
                        meta: {
                            title: '预核保进度',
                            access_name: 'get_cps_product_pre_uw_list'
                        },
                        component: resolve => {
                            require(['@/views/pre-underwriting/index'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/cps',
        name: 'cps',
        meta: {
            title: '商品管理',
            icon: 'ios-cart'
        },
        component: Main,
        children: [
            {
                path: 'cps-content',
                name: 'cps-content',
                meta: {
                    title: 'CPS管理',
                    access_name: 'cps_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'cps-content',
                        meta: {
                            title: 'CPS管理',
                            access_name: 'cps_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsList'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'cps-content',
                        meta: {
                            title: '新增CPS',
                            type: 'add',
                            access_name: 'cps_manage_add'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsAdd/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'cps-content',
                        meta: {
                            title: '编辑CPS',
                            type: 'edit',
                            access_name: 'cps_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsAdd/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'batch-upload',
                        name: 'cps-content',
                        meta: {
                            title: 'CPS批量上传',
                            access_name: 'cps_manage_upload'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsBatchUpload'], resolve)
                        }
                    },
                    {
                        path: 'view/:id/list',
                        name: 'cps-content',
                        meta: {
                            title: 'CPS链接列表',
                            access_name: 'cps_manage_view_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsViewList'], resolve)
                        }
                    },
                    {
                        path: 'code-entry/:id',
                        name: 'cps-content',
                        meta: {
                            title: '编码录入',
                            access_name: 'cps_manage_code_entry'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsCodeEntry'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/add',
                        name: 'cps-content',
                        meta: {
                            title: '新增方案',
                            access_name: 'cps_manage_coefficient_curd'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/edit/:edit_id',
                        name: 'cps-content',
                        meta: {
                            title: '编辑方案',
                            access_name: 'cps_manage_coefficient_curd'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/plan/:plan_id',
                        name: 'cps-content',
                        meta: {
                            title: '查看方案',
                            access_name: 'cps_manage_coefficient_view'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/cpsCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'product-coefficient/:type/:id',
                        name: 'cps-content',
                        meta: {
                            title: '产品系数',
                            access_name: 'cps_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-coefficient'], resolve)
                        }
                    },
                    {
                        path: 'product-coefficient/:type/:id/programme/:programme_id?',
                        name: 'cps-content',
                        meta: {
                            title: '产品系数详情',
                            access_name: 'cps_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-coefficient-detail'], resolve)
                        }
                    },
                    {
                        path: 'product-pre-sale-notification/:type/:id',
                        name: 'cps-content',
                        meta: {
                            title: '助销资料',
                            access_name: 'cps_manage_common_terms_list|cps_manage_poster_btn|cps_manage_sales_notification'
                        },
                        component: resolve => {
                            require(['@/views/product-pre-sale-notification'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id',
                        name: 'cps-content',
                        meta: {
                            title: '手续费设置',
                            access_name: 'commission_setting_page_list',
                            entry: 'cps-content'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/edit/:sid',
                        name: 'cps-content',
                        meta: {
                            title: '编辑手续费方案',
                            access_name: 'commission_setting_store',
                            pageType: 'edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/verify/:sid',
                        name: 'cps-content',
                        meta: {
                            title: '审核手续费方案',
                            access_name: 'commission_setting_verify',
                            pageType: 'verify'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/view/:sid',
                        name: 'cps-content',
                        meta: {
                            title: '查看手续费方案',
                            access_name: 'core_manage_list',
                            pageType: 'view'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/add',
                        name: 'cps-content',
                        meta: {
                            title: '新增手续费方案',
                            access_name: 'commission_setting_store',
                            pageType: 'add'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/copy/:sid',
                        name: 'cps-content',
                        meta: {
                            title: '复制手续费方案',
                            access_name: 'core_manage_list',
                            pageType: 'copy'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        name: 'cps-content',
                        path: 'website-operation/:type/:id',
                        meta: {
                            title: '发布商品',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/website-operation/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'core-content',
                name: 'core-content',
                meta: {
                    title: 'API管理',
                    access_name: 'core_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'core-content',
                        meta: {
                            title: 'API管理',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/core-info/core-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'core-content',
                        meta: {
                            title: '新增商品',
                            type: 'add',
                            access_name: 'core_manage_add'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/api-operate/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'core-content',
                        meta: {
                            title: '编辑商品',
                            type: 'edit',
                            access_name: 'core_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/api-operate/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/add',
                        name: 'core-content',
                        meta: {
                            title: '新增方案',
                            access_name: 'core_manage_coefficient_curd'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/coreCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/edit/:edit_id',
                        name: 'core-content',
                        meta: {
                            title: '编辑方案',
                            access_name: 'core_manage_coefficient_curd'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/coreCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'coefficient/:id/plan/:plan_id',
                        name: 'core-content',
                        meta: {
                            title: '查看方案',
                            access_name: 'core_manage_coefficient_view'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/coreCoefficientAdd'], resolve)
                        }
                    },
                    {
                        path: 'product-coefficient/:type/:id',
                        name: 'core-content',
                        meta: {
                            title: '产品系数',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-coefficient'], resolve)
                        }
                    },
                    {
                        path: 'product-coefficient/:type/:id/programme/:programme_id?',
                        name: 'core-content',
                        meta: {
                            title: '产品系数详情',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-coefficient-detail'], resolve)
                        }
                    },
                    {
                        path: 'product-pre-sale-notification/:type/:id',
                        name: 'core-content',
                        meta: {
                            title: '助销资料',
                            access_name: 'core_manage_common_terms_list|core_manage_poster_btn|core_manage_sales_notification'
                        },
                        component: resolve => {
                            require(['@/views/product-pre-sale-notification'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id',
                        name: 'core-content',
                        meta: {
                            title: '手续费设置',
                            access_name: 'commission_setting_page_list',
                            entry: 'core-content'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/edit/:sid',
                        name: 'core-content',
                        meta: {
                            title: '编辑手续费方案',
                            access_name: 'commission_setting_store',
                            pageType: 'edit'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/verify/:sid',
                        name: 'core-content',
                        meta: {
                            title: '审核手续费方案',
                            access_name: 'commission_setting_verify',
                            pageType: 'verify'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/view/:sid',
                        name: 'core-content',
                        meta: {
                            title: '查看手续费方案',
                            access_name: 'core_manage_list',
                            pageType: 'view'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/add',
                        name: 'core-content',
                        meta: {
                            title: '新增手续费方案',
                            access_name: 'commission_setting_store',
                            pageType: 'add'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        path: 'commission-charge/:id/copy/:sid',
                        name: 'core-content',
                        meta: {
                            title: '复制手续费方案',
                            access_name: 'core_manage_list',
                            pageType: 'copy'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/component/commission-charge-edit.vue'], resolve)
                        }
                    },
                    {
                        name: 'core-content',
                        path: 'website-operation/:type/:id',
                        meta: {
                            title: '发布商品',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/website-operation/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'persistency-rate',
                name: 'persistency-rate',
                meta: {
                    title: '继续率计算关联',
                    access_name: 'product_group_page_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'persistency-rate',
                        meta: {
                            title: '继续率计算关联',
                            access_name: 'product_group_page_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/persistency-rate/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'persistency-rate',
                        meta: {
                            title: '新建合并产品',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/persistency-rate/editOrAdd.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit',
                        name: 'persistency-rate',
                        meta: {
                            title: '编辑合并产品',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/persistency-rate/editOrAdd.vue'], resolve)
                        }
                    },
                    {
                        path: 'add-single',
                        name: 'persistency-rate',
                        meta: {
                            title: '新建单品',
                            access_name: 'core_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/persistency-rate/createSingle.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'list-cover-material',
                name: 'list-cover-material',
                meta: {
                    title: '列表封面素材',
                    access_name: 'product/cover-material/cover-page-list|product/cover-material/category/list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'list-cover-material',
                        meta: {
                            title: '列表封面素材',
                            access_name: 'product/cover-material/cover-page-list|product/cover-material/category/list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/list-cover-material/index.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/website-manage',
        name: 'website-manage',
        meta: {
            title: '官网设置',
            icon: 'ios-create'
        },
        component: Main,
        children: [
            {
                path: '/website-banner',
                name: 'website-banner',
                meta: {
                    title: 'banner设置',
                    access_name: 'website_banner_list_with_page'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'website-banner',
                        meta: {
                            title: 'banner设置',
                            access_name: 'website_banner_list_with_page'
                        },
                        component: resolve => {
                            require(['@/views/website-manage/banner-manage/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'banner-operation/add',
                        name: 'banner-operation',
                        meta: {
                            title: '新增',
                            access_name: 'website_banner_create'
                        },
                        component: resolve => {
                            require(['@/views/website-manage/banner-operation/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'banner-operation/:id',
                        name: 'banner-operation',
                        meta: {
                            title: '编辑',
                            access_name: 'website_banner_update'
                        },
                        component: resolve => {
                            require(['@/views/website-manage/banner-operation/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: '/website-cate',
                name: 'website-cate',
                meta: {
                    title: '官网分类设置',
                    access_name: 'website_product_category_list_with_page'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'website-cate',
                        meta: {
                            title: '官网分类设置',
                            access_name: 'website_product_category_list_with_page'
                        },
                        component: resolve => {
                            require(['@/views/website-manage/cate-manage/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: '/product-display',
                name: 'product-display',
                meta: {
                    title: '产品显示',
                    access_name: 'product/display-rule/get-setting'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'product-display',
                        meta: {
                            title: '产品显示',
                            access_name: 'product/display-rule/get-setting'
                        },
                        component: resolve => {
                            require(['@/views/website-manage/product-display/index.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/question-manage',
        name: 'question-manage',
        meta: {
            title: '问答管理',
            icon: 'ios-create'
        },
        component: Main,
        children: [
            {
                path: 'question-manage',
                name: 'question-manage',
                meta: {
                    title: '问答管理',
                    access_name: 'question-tag|question-content'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'question-manage',
                        meta: {
                            title: '问答管理',
                            type: '',
                            access_name: 'question-tag|question-content'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/question-manage'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/service-charge',
        name: 'service-charge',
        meta: {
            title: '手续费管理',
            icon: 'logo-yen'
        },
        component: Main,
        children: [
            // {
            //   path: 'base-programme',
            //   name: 'base-programme',
            //   meta: {
            //     title: '基础方案'
            //   },
            //   component: onlyRouterView,
            //   children: [
            //     {
            //       path: '',
            //       name: 'base-programme',
            //       meta: {
            //         title: '基础方案',
            //         access_name: 'base_programme_list'
            //       },
            //       component: resolve => {
            //         require(['@/views/service-charge/base-programme'], resolve)
            //       }
            //     },
            //     {
            //       path: 'add/:id?',
            //       name: 'base-programme',
            //       meta: {
            //         title: '新建方案',
            //         access_name: 'add_programme',
            //         type: 'add'
            //       },
            //       component: resolve => {
            //         require(['@/views/service-charge/programme-operate'], resolve)
            //       }
            //     },
            //     {
            //       path: 'edit/:id',
            //       name: 'base-programme',
            //       meta: {
            //         title: '修改方案',
            //         access_name: 'edit_programme',
            //         type: 'edit'
            //       },
            //       component: resolve => {
            //         require(['@/views/service-charge/programme-operate'], resolve)
            //       }
            //     }
            //   ]
            // },
        ]
    },
    {
        path: '/underwrite',
        name: 'underwrite',
        meta: {
            title: '核保健告管理',
            icon: 'ios-create'
        },
        component: Main,
        children: [
            {
                path: 'underwriting-health-notice',
                name: 'underwriting-health-notice',
                meta: {
                    title: ' 核保健告管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'underwrite',
                        name: 'underwriting-health-notice',
                        meta: {
                            title: '智核管理',
                            type: 'underwrite',
                            access_name: 'underwriting-notice-manage|health-notice-manage'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/manage'], resolve)
                        }
                    },
                    {
                        path: 'product-manage/:type',
                        name: 'product-manage',
                        meta: {
                            title: '核保健告产品管理',
                            type: '',
                            access_name: 'underwriting-notice-manage|health-notice-manage'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-manage'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'underwrite-rules',
                name: 'underwrite-rules',
                meta: {
                    title: '投保规则管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'underwrite-rules',
                        meta: {
                            title: '投保规则管理',
                            type: 'add',
                            access_name: 'underwrite-rules'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/underwrite-rules'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'insurance-rules',
                name: 'insurance-rules',
                meta: {
                    title: '核保规则管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'insurance-rules',
                        meta: {
                            title: '核保规则管理',
                            type: 'add',
                            access_name: 'insurance-rules'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/insurance-rules'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'product-compare',
                name: 'product-compare',
                meta: {
                    title: '产品对比管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'product-compare',
                        meta: {
                            title: '产品对比管理',
                            access_name: 'product_evaluation_product_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-compare'], resolve)
                        }
                    },
                    {
                        path: 'edit-product-compare',
                        name: 'edit-product-compare',
                        meta: {
                            title: '一览表',
                            access_name: 'product_evaluation_product_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/product-compare/edit-product-compare'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'service-preservation',
                name: 'service-preservation',
                meta: {
                    title: '客服保全管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'service-preservation',
                        meta: {
                            title: '客服保全管理',
                            type: 'add',
                            access_name: 'customer-service-list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/service-preservation'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'claim-rules',
                name: 'claim-rules',
                meta: {
                    title: '理赔规则管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'claim-rules',
                        meta: {
                            title: '理赔规则管理',
                            type: 'add',
                            access_name: 'claim-settlement-list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/claim-rules'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'sales-guidelines',
                name: 'sales-guidelines',
                meta: {
                    title: '售后指引管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'sales-guidelines',
                        meta: {
                            title: '售后指引管理',
                            type: 'add',
                            access_name: 'product-sales-guidance-list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/sales-guidelines'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'disease-management',
                name: 'disease-management',
                meta: {
                    title: '病种明细管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: 'add',
                        name: 'disease-management',
                        meta: {
                            title: '病种明细管理',
                            type: 'add',
                            access_name: 'product_disease_page_list'
                        },
                        component: resolve => {
                            require(['@/views/cps-manage/disease-management'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/content',
        name: 'content',
        meta: {
            title: '内容管理',
            icon: 'ios-create'
        },
        component: Main,
        children: [
            {
                path: 'poster-content',
                name: 'poster-content',
                meta: {
                    title: '海报管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'poster-content',
                        meta: {
                            title: '海报管理',
                            access_name: 'poster_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/poster/poster-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'poster-content',
                        meta: {
                            title: '新增海报',
                            type: 'add',
                            access_name: 'poster_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/poster/poster-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'poster-content',
                        meta: {
                            title: '编辑海报',
                            type: 'edit',
                            access_name: 'poster_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/poster/poster-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'video-content',
                name: 'video-content',
                meta: {
                    title: '视频管理',
                    access_name: 'video_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'video-content',
                        meta: {
                            title: '视频管理',
                            access_name: 'video_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/video/video-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'video-content',
                        meta: {
                            title: '新增视频',
                            type: 'add',
                            access_name: 'video_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/video/video-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'video-content',
                        meta: {
                            title: '编辑视频',
                            type: 'edit',
                            access_name: 'video_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/video/video-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'article-content',
                name: 'article-content',
                meta: {
                    title: '文章管理',
                    access_name: 'article_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'article-content',
                        meta: {
                            title: '文章管理',
                            access_name: 'article_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/article/article-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'article-content',
                        meta: {
                            title: '新增文章',
                            type: 'add',
                            access_name: 'article_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/article/article-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id/:post_type',
                        name: 'article-content',
                        meta: {
                            title: '编辑文章',
                            type: 'edit',
                            access_name: 'poster_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/article/article-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'drafts',
                        name: 'article-content',
                        meta: {
                            title: '草稿箱',
                            type: 'drafts',
                            access_name: 'article_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/article/drafts-list.vue'], resolve)
                        }
                    },
                    {
                        path: 'draft/edit/:id/:post_type',
                        name: 'article-content',
                        meta: {
                            title: '编辑草稿箱文章',
                            type: 'edit',
                            access_name: 'poster_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/article/article-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'after-sales-guidelines',
                name: 'after-sales-guidelines',
                component: onlyRouterView,
                meta: {
                    title: '售后指引管理',
                    access_name: 'platform_guide_list'
                },
                children: [
                    {
                        path: '',
                        name: 'after-sales-guidelines',
                        meta: {
                            title: '售后指引管理',
                            access_name: 'platform_guide_list'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/after-sale/after-sales-guidelines.vue'], resolve)
                        }
                    },
                    {
                        path: 'add-after-sales',
                        name: 'after-sales-guidelines',
                        meta: {
                            title: '编辑指引',
                            access_name: 'platform_guide_list'
                        },
                        component: resolve => {
                            require(['@/views/content-manage/after-sale/add-after-sales.vue'], resolve)
                        }
                    }
                ]
            }
            // {
            //   path: 'question-content',
            //   name: 'question-content',
            //   meta: {
            //     title: '问答管理'
            //   },
            //   component: onlyRouterView,
            //   children: [
            //     {
            //       path: '',
            //       name: 'question-content',
            //       meta: {
            //         title: '问答管理',
            //         access_name: 'question_manage_list'
            //       },
            //       component: resolve => {
            //         require(['@/views/content-manage/question/list'], resolve);
            //       }
            //     },
            //     {
            //       path: 'add',
            //       name: 'question-content',
            //       meta: {
            //         title: '新增问答',
            //         type: 'add',
            //         access_name: 'question_manage_add'
            //       },
            //       component: resolve => {
            //         require(['@/views/content-manage/question/add'], resolve);
            //       }
            //     },
            //     {
            //       path: 'edit/:id',
            //       name: 'question-content',
            //       meta: {
            //         title: '问答编辑',
            //         type: 'edit',
            //         access_name: 'question_manage_edit'
            //       },
            //       component: resolve => {
            //         require(['@/views/content-manage/question/add'], resolve);
            //       }
            //     }
            //   ]
            // }
        ]
    },
    {
        path: '/supplier',
        name: 'supplier-manage',
        meta: {
            title: '供应商管理',
            icon: 'ios-globe'
        },
        component: Main,
        children: [
            {
                path: 'company-manage',
                name: 'company-manage',
                meta: {
                    title: '公司管理',
                    access_name: 'company_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'company-manage',
                        meta: {
                            title: '公司管理',
                            access_name: 'company_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/company-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'company-manage',
                        meta: {
                            title: '新增公司',
                            type: 'add',
                            access_name: 'company_manage_add'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/company-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'company-manage',
                        meta: {
                            title: '编辑公司',
                            type: 'edit',
                            access_name: 'company_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/company-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'claim-information/:id',
                        name: 'claim-information',
                        meta: {
                            title: '理赔资料',
                            access_name: 'claim_information'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/claim-information/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'goods-manage',
                name: 'goods-manage',
                meta: {
                    title: '供应商管理',
                    access_name: 'goods_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'goods-manage',
                        meta: {
                            title: '供应商管理',
                            access_name: 'goods_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/goods-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'goods-manage',
                        meta: {
                            title: '新增供应商',
                            access_name: 'goods_manage_add'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/goods-add.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'goods-manage',
                        meta: {
                            title: '编辑供应商',
                            access_name: 'goods_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/goods-add.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'claim-process',
                name: 'claim-process',
                meta: {
                    title: '出单平台理赔流程',
                    access_name: 'claim_process'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'claim-process',
                        meta: {
                            title: '出单平台理赔流程',
                            access_name: 'claim_process'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/claim-process/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'set-claim-process/:type?',
                        name: 'set-claim-process',
                        meta: {
                            title: '理赔指引设置',
                            access_name: 'claim_process'
                        },
                        component: resolve => {
                            require(['@/views/supplier-manage/claim-process/claim-guidelines.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/proposal',
        name: 'proposal',
        meta: {
            title: '计划书管理',
            icon: 'ios-create'
        },
        component: Main,
        children: [
            {
                path: 'proposal-setting',
                name: 'proposal-setting',
                meta: {
                    title: '产品设置',
                    access_name: 'proposal_product_list_page'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'proposal-setting',
                        meta: {
                            title: '产品设置',
                            access_name: 'proposal_product_list_page'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-setting/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'rate-operate',
                        name: 'proposal-setting',
                        meta: {
                            title: '费率设置',
                            access_name: 'proposal_product_rate_save'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-setting/proposal-rate-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'operate',
                        name: 'proposal-setting',
                        meta: {
                            title: '产品设置',
                            access_name: 'proposal_product_update'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-setting/proposal-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'proposal-guarantee',
                name: 'proposal-guarantee',
                meta: {
                    title: '保障管理',
                    access_name: 'proposal_guarantee_responsibility_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'proposal-guarantee',
                        meta: {
                            title: '保障管理',
                            access_name: 'proposal_guarantee_responsibility_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-guarantee/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'operate',
                        name: 'proposal-guarantee',
                        meta: {
                            title: '保障管理',
                            access_name: 'proposal_guarantee_responsibility_add'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-guarantee/proposal-guarantee-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'proposal-savings',
                name: 'proposal-savings',
                meta: {
                    title: '储蓄产品管理',
                    access_name: 'proposal_deposit_product_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'proposal-savings',
                        meta: {
                            title: '储蓄产品管理',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-savings/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'operate',
                        name: 'proposal-savings',
                        meta: {
                            title: '储蓄产品管理',
                            access_name: 'proposal_deposit_product_detail'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-savings/proposal-savings-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'rate-manager',
                        name: 'proposal-savings',
                        meta: {
                            title: '储蓄产品管理',
                            access_name: 'proposal_deposit_product_rate_detail'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-savings/proposal-savings-rate-manage.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'proposal-financial-setting',
                name: 'proposal-financial-setting',
                meta: {
                    title: '理财规划设置',
                    access_name: '/financial_proposal/all_setting_overview'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'proposal-financial-setting',
                        meta: {
                            title: '理财规划设置',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-financial-setting/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'setting-market-env',
                        name: 'proposal-financial-setting',
                        meta: {
                            title: '市场环境',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-financial-setting/setting-market-env.vue'], resolve)
                        }
                    },
                    {
                        path: 'setting-wage-avg',
                        name: 'proposal-financial-setting',
                        meta: {
                            title: '社平工资',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-financial-setting/setting-wage-avg.vue'], resolve)
                        }
                    },
                    {
                        path: 'setting-regional-economy',
                        name: 'proposal-financial-setting',
                        meta: {
                            title: '国家经济',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-financial-setting/setting-regional-economy.vue'], resolve)
                        }
                    },
                    {
                        path: 'setting-educational-expenses',
                        name: 'proposal-financial-setting',
                        meta: {
                            title: '教育费用',
                            access_name: 'proposal_deposit_product_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-financial-setting/setting-educational-expenses.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'proposal-template',
                name: 'proposal-template',
                meta: {
                    title: '家庭风险分析模板',
                    access_name: 'proposal_family_analysis_template_group_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'proposal-template',
                        meta: {
                            title: '家庭风险分析模板',
                            access_name: 'proposal_family_analysis_template_group_list'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-template/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'proposal-template',
                        meta: {
                            title: '新增计划书模板',
                            access_name: 'proposal_family_analysis_template_add'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-template/template-add.vue'], resolve)
                        }
                    },
                    {
                        path: 'detail',
                        name: 'proposal-template',
                        meta: {
                            title: '查看家庭风险分析模板',
                            access_name: 'proposal_family_analysis_template_detail'
                        },
                        component: resolve => {
                            require(['@/views/proposal/proposal-template/template-show.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/refund',
        name: 'refund',
        meta: {
            title: '代收款管理',
            icon: 'ios-body'
        },
        component: Main,
        children: [
            {
                path: 'refund-manage',
                name: 'refund-manage',
                meta: {
                    title: '退款处理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'refund-manage',
                        meta: {
                            title: '退款处理',
                            access_name: 'admin_refund_manage'
                        },
                        component: resolve => {
                            require(['@/views/refund-manage/refund-manage.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/renewal-manage',
        name: 'renewal-manage',
        meta: {
            title: '续保续期管理',
            icon: 'ios-body'
        },
        component: Main,
        children: [
            {
                path: 'detailed-list',
                name: 'detailed-list',
                meta: {
                    title: '清单管理',
                    access_name: 'renewal_list_management'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'detailed-list',
                        meta: {
                            title: '清单管理',
                            access_name: 'renewal_list_management'
                        },
                        component: resolve => {
                            require(['@/views/renewal-manage/detailed-list'], resolve)
                        }
                    },
                    {
                        path: 'policy-detail/:id',
                        name: 'detailed-list',
                        meta: {
                            title: '保单详情',
                            access_name: 'renewal_policy_detail|renewal_policy_detail_secret|renewal_policy_detail_part'
                        },
                        component: resolve => {
                            require(['@/views/renewal-manage/policy-detail'], resolve)
                        }
                    },
                    {
                        path: 'import-detail/:id',
                        name: 'detailed-list',
                        meta: {
                            title: '导入详情',
                            access_name: 'renewal_import_list'
                        },
                        component: resolve => {
                            require(['@/views/renewal-manage/import-detail'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/commission',
        name: 'commission',
        meta: {
            title: '手续费管理',
            icon: 'ios-body'
        },
        component: Main,
        children: [
            {
                path: 'first-commission-order',
                name: 'commission',
                meta: {
                    title: '首年手续费清单',
                    access_name: 'commission_setting_get_first_year_service_charge_list'
                },
                component: onlyRouterView,
                children: [
                    // {
                    //   path: '',
                    //   name: 'commission',
                    //   meta: {
                    //     title: '首年手续费清单',
                    //     access_name: 'commission_setting_get_first_year_service_charge_list'
                    //   },
                    //   component: resolve => {
                    //     require(['@/views/commission/first-commission-order.vue'], resolve)
                    //   }
                    // }
                ]
            }
        ]
    },
    {
        path: '/start-class-applet',
        name: 'startClassApplet',
        meta: {
            title: '开课吧小程序',
            icon: 'ios-book'
        },
        component: Main,
        children: [
            {
                path: 'course-manage',
                name: 'course-manage-applet',
                meta: {
                    title: '课程管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'course-manage-applet',
                        meta: {
                            title: '课程管理',
                            access_name: 'kkb/course/get-list-by-category'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/course-manage/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'add-course',
                        name: 'course-manage-applet',
                        meta: {
                            title: '课程管理',
                            access_name: 'kkb/course/add|kkb/course/edit'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/course-manage/add-course/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'recommend-manage',
                        name: 'recommend-manage',
                        meta: {
                            title: '推荐课程管理',
                            access_name: 'kkb/course/add|kkb/course/edit'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/course-manage/recommend-manage/index.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'operational-analysis',
                name: 'operational-analysis-applet',
                meta: {
                    title: '运营分析'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'operational-analysis-applet',
                        meta: {
                            title: '运营分析',
                            access_name: 'kkb/statistics/get-course-statistics|kkb/statistics/get-course-play-log'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/operational-analysis/index/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'course-classify',
                name: 'course-classify-applet',
                meta: {
                    title: '课程分类'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'course-classify-applet',
                        meta: {
                            title: '课程分类',
                            access_name: 'kkb/course/category/get-list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/course-classify/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'second-category',
                        name: 'course-classify-applet',
                        meta: {
                            title: '课程分类',
                            access_name: 'kkb/course/category/sub/get-list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/course-classify/second-category.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'questionnaire-manage',
                name: 'questionnaire-manage-applet',
                meta: {
                    title: '评测管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'questionnaire-manage-applet',
                        meta: {
                            title: '评测管理',
                            access_name: 'kkb/questionnaire/statistics|kkb/questionnaire/index|kkb/questionnaire/details|kkb/secret-signal/queried/list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/questionnaire-manage/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'cipher-decode/cipher-library',
                        name: 'cipher-library-applet',
                        meta: {
                            title: '评测管理',
                            access_name: 'kkb/questionnaire/statistics|kkb/secret-signal/list|kkb/secret-signal/upload|kkb/secret-signal/upload-log/list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/questionnaire-manage/cipher-decode/cipher-library'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'banner-setting',
                name: 'banner-setting-applet',
                meta: {
                    title: 'banner设置'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'banner-setting-applet',
                        meta: {
                            title: 'banner设置',
                            access_name: 'kkb/banner/get-lists'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/banner-setting/index/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit',
                        name: 'banner-setting-applet',
                        meta: {
                            title: 'banner设置',
                            access_name: 'kkb/banner/add-banner|kkb/banner/edit-banner'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/banner-setting/edit/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'internal-manage',
                name: 'internal-manage-applet',
                meta: {
                    title: '内部人员管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'internal-manage-applet',
                        meta: {
                            title: '内部人员管理',
                            access_name: 'kkb/user/internal-user'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/internal-manage/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'resource-pool',
                name: 'resource-pool-applet',
                meta: {
                    title: '资源库'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'resource-pool-applet',
                        meta: {
                            title: '资源库',
                            access_name: 'kkb/course/get-course-resource-list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/resource-pool/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'marketing-manage',
                name: 'marketing-manage-applet',
                meta: {
                    title: '营销管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'marketing-manage-applet',
                        meta: {
                            title: '营销管理',
                            access_name: 'kkb/coupons/get-page-list|kkb/settings/get-watch-settings'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/marketing-manage/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'exchange-detail',
                        name: 'marketing-manage-applet',
                        meta: {
                            title: '优惠券兑换详情',
                            access_name: 'kkb/coupons/get-page-list'
                        },
                        component: resolve => {
                            require(['@/views/start-class-applet/marketing-manage/components/coupons-setting/components/exchange-detail.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/start-class',
        name: 'startClass',
        meta: {
            title: '开课吧',
            icon: 'ios-book'
        },
        component: Main,
        children: [
            {
                path: 'class-manage',
                name: 'class-manage',
                meta: {
                    title: '课程管理',
                    access_name: 'course_get_course_lists'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'class-manage',
                        meta: {
                            title: '课程管理',
                            access_name: 'course_get_course_lists'
                        },
                        component: resolve => {
                            require(['@/views/start-class/class-manage/index/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit',
                        name: 'class-manage',
                        meta: {
                            title: '课程管理',
                            access_name: 'course_add_course'
                        },
                        component: resolve => {
                            require(['@/views/start-class/class-manage/edit/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'operational-analysis',
                name: 'operational-analysis',
                meta: {
                    title: '运营分析'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'operational-analysis',
                        meta: {
                            title: '运营分析',
                            access_name: 'course_analysis'
                        },
                        component: resolve => {
                            require(['@/views/start-class/operational-analysis/index/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'banner-setting',
                name: 'banner-setting',
                meta: {
                    title: 'banner设置'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'banner-setting',
                        meta: {
                            title: 'banner设置',
                            access_name: 'course_get_course_banner_lists'
                        },
                        component: resolve => {
                            require(['@/views/start-class/banner-setting/index/index.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit',
                        name: 'banner-setting',
                        meta: {
                            title: 'banner设置',
                            access_name: 'course_add_course_banner'
                        },
                        component: resolve => {
                            require(['@/views/start-class/banner-setting/edit/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'questionnaire-manage',
                name: 'questionnaire-manage',
                meta: {
                    title: '问卷管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'questionnaire-manage',
                        meta: {
                            title: '问卷管理',
                            access_name: 'questionnaire/statistics|questionnaire/index|questionnaire/answer-record'
                        },
                        component: resolve => {
                            require(['@/views/start-class/questionnaire-manage/index.vue'], resolve)
                        }
                    },
                ]
            },
            {
                path: 'internal-manage',
                name: 'internal-manage',
                meta: {
                    title: '内部人员管理'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'internal-manage',
                        meta: {
                            title: '内部人员管理',
                            access_name: 'user/internal'
                        },
                        component: resolve => {
                            require(['@/views/start-class/internal-manage/index.vue'], resolve)
                        }
                    },
                ]
            }
        ]
    },
    {
        path: '/account',
        name: 'account',
        meta: {
            title: '账号管理',
            icon: 'ios-body'
        },
        component: Main,
        children: [
            {
                path: 'admin-account',
                name: 'admin-account',
                meta: {
                    title: '成员管理',
                    access_name: 'admin_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'admin-account',
                        meta: {
                            title: '成员管理',
                            access_name: 'admin_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/admin/account-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'admin-account',
                        meta: {
                            title: '新增成员',
                            type: 'add',
                            access_name: 'admin_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/admin/account-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-account',
                        meta: {
                            title: '编辑成员',
                            type: 'edit',
                            access_name: 'admin_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/admin/account-operate.vue'], resolve)
                        }
                    }
                ]
            },
            {
                path: 'role-account',
                name: 'role-account',
                meta: {
                    title: '角色管理',
                    access_name: 'role_manage_list'
                },
                component: onlyRouterView,
                children: [
                    {
                        path: '',
                        name: 'role-account',
                        meta: {
                            title: '角色管理',
                            access_name: 'role_manage_list'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/role/role-lists.vue'], resolve)
                        }
                    },
                    {
                        path: 'add',
                        name: 'role-account',
                        meta: {
                            title: '新增角色',
                            type: 'add',
                            access_name: 'role_manage_create'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/role/role-operate.vue'], resolve)
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'role-account',
                        meta: {
                            title: '编辑角色',
                            type: 'edit',
                            access_name: 'role_manage_edit'
                        },
                        component: resolve => {
                            require(['@/views/account-manage/role/role-operate.vue'], resolve)
                        }
                    }
                ]
            }
        ]
    }
]

export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录'
    },
    component: resolve => {
        require(['@/views/login/login.vue'], resolve)
    }
}

export const otherRouter = {
    path: '/',
    name: 'other-router',
    redirect: '/home',
    meta: {
        title: '首页'
    },
    component: Main,
    children: [
        {
            path: 'home',
            name: 'home_index',
            meta: {
                title: '首页'
            },
            component: resolve => {
                require(['@/views/home/home.vue'], resolve)
            }
        }
    ]
}

export const forbiddenRouter = {
    path: '/forbidden',
    name: 'forbidden',
    alias: '/forbidden-new',
    meta: {
        title: '暂无权限'
    },
    component: resolve => {
        require(['@/views/error-page/forbidden.vue'], resolve)
    }
}

export const notFoundRouter = {
    path: '/*',
    name: 'not-found',
    meta: {
        title: '404-Page Lost'
    },
    component: resolve => {
        require(['@/views/error-page/not-found.vue'], resolve)
    }
}

export const previewRouter = {
    path: '/website-preview',
    name: 'website-preview',
    meta: {
        title: '预览'
    },
    component: resolve => {
        require(['@/views/website-manage/website-preview/index.vue'], resolve)
    }
}

export const routers = [loginRouter, previewRouter, forbiddenRouter, otherRouter, ...mainRouter, notFoundRouter]



// WEBPACK FOOTER //
// ./src/router/router.js